import { createContext, useContext, useState, useCallback, useEffect } from 'react'
import { authApi } from './api'

const AppContext = createContext({})

export function AppProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [toastMsg, setToastMsg] = useState(null)
  const isAdmin = user?.role === 'admin'
  const isTech = user?.role === 'technicien'

  // Vérifier le token au démarrage
  useEffect(() => {
    const token = localStorage.getItem('hs_token')
    if (!token) {
      setLoading(false)
      return
    }
    authApi.me()
      .then(r => setUser(r.data))
      .catch(() => {
        // Token invalide ou expiré → nettoyer et retourner au login
        localStorage.removeItem('hs_token')
        setUser(null)
      })
      .finally(() => setLoading(false))
  }, [])

  const showToast = useCallback((msg, type = 'success') => {
    setToastMsg({ msg, type, id: Date.now() })
  }, [])

  const login = useCallback(async (email, password) => {
    const r = await authApi.login({ email, password })
    localStorage.setItem('hs_token', r.data.token)
    setUser(r.data.user)
  }, [])

  const logout = useCallback(async () => {
    try { await authApi.logout() } catch { }
    localStorage.removeItem('hs_token')
    setUser(null)
  }, [])

  return (
    <AppContext.Provider value={{ user, loading, login, logout, toast: showToast, isAdmin, isTech }}>
      {children}
      {toastMsg && (
        <Toast
          key={toastMsg.id}
          msg={toastMsg.msg}
          type={toastMsg.type}
          onClose={() => setToastMsg(null)}
        />
      )}
    </AppContext.Provider>
  )
}

function Toast({ msg, type, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 3500)
    return () => clearTimeout(t)
  }, [])

  return (
    <div className={`toast ${type}`}>
      <i className={`ti ti-${type === 'success' ? 'check-circle' : 'alert-circle'}`} />
      {msg}
    </div>
  )
}

export const useApp = () => useContext(AppContext)
